var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('header',[_c('RegisterTop')],1),_vm._v(" "),_c('div',{staticClass:"step"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"foot"},[_c('foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }